import PATHS from '../constants';

function fetchJobs() {
    const headers = {
        Accept: 'application/json',
        'Content-Type': 'application/json',
    };
    return fetch(PATHS.HOME_JOBS, {
        method: 'GET',
        dataType: 'json',
        headers,
    });
};

export default fetchJobs;